<template>
  <div style="overflow:auto;height:90vh">
    <ul>
      <!--产品列表-->
      <li
        v-for="(product,index) in products"
        :key="product.id"
        :class="['productitem', {'productitemon':index==hoverIndex}]"
        @mouseover="hoverIndex = index"
        @mouseout="hoverIndex = -1"
      >
        <div class="removeP" v-show="index==hoverIndex">
          <span style="float:left">
            <i class="el-icon-close" title="删除" @click="deleteProduct(product.id)"></i>
          </span>
          <span style="float:right">
            <i class="el-icon-refresh-left" title="恢复" @click="recoveryProduct(product.id)"></i>
          </span>
        </div>
        <router-link :to="'/gm/product/view/'+product.id">
          <el-container>
            <el-main>
              <el-image class="productitemimg" :src="product.image" fit="cover"></el-image>
            </el-main>
            <el-footer class="producttitle" height="40px">{{ product.name }}</el-footer>
          </el-container>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import config from "../../../api/config";
import {
  getDelList,
  recoveryProduct,
  deleteProduct
} from "../../../api/gm/api-product";
export default {
  data() {
    return {
      staticURL: config.staticURL, //图片域名
      hoverIndex: -1, //判断选中状态
      products: null
    };
  },
  created() {
    getDelList().then(res => {
      if (res.code === 0) {
        this.products = res.data;
        this.products.forEach(i => {
          i.image = this.staticURL + i.image;
        });
      } else {
        console.log(res.msg);
      }
    });
  },
  methods: {
    //..恢复
    recoveryProduct(pid) {
      this.$confirm("确认恢复?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          recoveryProduct(pid).then(res => {
            if (res.code === 0) {
              this.$message({
                message: "产品已恢复",
                type: "success",
                onClose: this.$router.go(0)
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    //..彻底删除
    deleteProduct(pid) {
      this.$confirm("彻底删除数据?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          deleteProduct(pid).then(res => {
            if (res.code === 0) {
              this.$message({
                message: "产品已删除",
                type: "success",
                onClose: this.$router.go(0)
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.productitem {
  width: 20%;
  margin: 10px 5%;
  float: left;
  list-style: none;
  text-align: center;
  cursor: pointer;
  border: 1px solid #e7e6e6;
}
.productitemon {
  border: 1px solid #1f8fff;
  color: #1f8fff;
}

.productitemimg {
  margin: 10px 0;
  width: 100px;
  height: 100px;
}
.producttitle {
  font-size: 12px;
  padding: 5px;
}
.removeP {
  margin: 5px 5px 0 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/product/recycle.vue